import { render } from "./createRules.vue?vue&type=template&id=04d9f662&scoped=true"
import script from "./createRules.vue?vue&type=script&lang=js"
export * from "./createRules.vue?vue&type=script&lang=js"

import "./createRules.vue?vue&type=style&index=0&id=04d9f662&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d9f662"]])

export default __exports__